/*eslint-disable */
import React, { Component } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import OrderDetails from "./orderDetails";
import { translate } from "react-i18next";
import FormikModalAllot from "./modalAllot";
import ReadAxios from "../axiosComponent/read";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import ModalVehicleDetail from "./vehicleDetails";
import VehicleDetailsModal from "./driverDetailsComponent/vehicleDetailsModal";
import StatusHistory from './statusHistory';
import ModalBroadCast from "./modalBroadCast";
import ModalReBroadcast from "./modalRebroadcast";
import ModalUndoBroadcast from "./modalUndoBroadcast";
import ModalUndoAllotedVendor from "./modalUndoAllotedVendor";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import DeleteAxios from "../axiosComponent/delete";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  consigneeConsignorCheck, ALL_ALLOW_ROLES, ShipmentUndoBtnDisabled, shipmentTableBookingNumberHeaderCell,
  remarksOnUndoAllotVendor, customerNo, usePartnerInsteadOfVendor, order_allotment_status,
  noModalUndoBroadcastRoles, noModalAllotRole, noModalBroadcastRole
} from '../../utils/constant'

export class ShipmentOrderTable extends Component {
  constructor(props) {
    super(props);
    let queryParameters = props?.history?.location?.search?.split('&')
    let openOrderModal = queryParameters && queryParameters.length && queryParameters[2] && queryParameters[2].split('=')
    this.state = {
      openViewModal: openOrderModal && openOrderModal.length && openOrderModal[1] == 'true' ? true : false,
      openVehicleModal: false,
      openVehicleDetailsModal: false,
      order_fetch: this.props.order_fetch,
      replies_fetch: null,
      currentOrder: 0,
      historyModal: false,
      vendor_order_id: null
    };
  }

  handleModelOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ openViewModal: true });
  };

  handleVehicleModelOpen = () => {
    this.setState({ openVehicleModal: true });
  };

  historyModal = (e) => {
    this.setState({
      historyModal: true,
      vendor_order_id: this.state.order_fetch.vendor_order_id
    })
  }

  // handleVehicleModelOpen = () => {
  //   this.setState({ openVehicleDetailsModal: true });
  // }

  componentDidMount() {
    // this.fetchOrderDetails();
    if (
      this.state.order_fetch &&
      this.state.order_fetch?.allotment_status &&
      this.state.order_fetch?.allotment_status?.allotment_code == order_allotment_status.broadcast
    ) {
      this.fetchVendorsReply(this.state.order_fetch?.vendor_order_id);
    }
  }

  componentWillReceiveProps(nextProps) {
    
    if (nextProps.currentOrder !== this.state.currentOrder) {
      this.setState({ currentOrder: nextProps.currentOrder })
    }
    if (nextProps?.order_fetch !== this.state.order_fetch) {
      this.setState({ order_fetch : nextProps.order_fetch })
        if (
          nextProps.order_fetch?.allotment_status &&
          nextProps.order_fetch?.allotment_status.allotment_code == order_allotment_status.broadcast
        ) {
          this.fetchVendorsReply(this.state.order_fetch?.vendor_order_id);
        }
    }
  }

  fetchOrderDetails = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${this.props.orderData}`,
    })
      .then((res) => {
        //console.log("refetched order", res);
        this.setState({
          order_fetch: res.data.order,
        });
        if (
          res.data.order.allotment_status &&
          res.data.order.allotment_status.allotment_code == order_allotment_status.broadcast
        ) {
          this.fetchVendorsReply(res.data.order.vendor_order_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  fetchVendorsReply = (order_id) => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/broadcast/vendor/replies`,
    })
      .then((res) => {
        this.setState({
          replies_fetch: res.data.vendor_replies,
          isLoading: false,
        });
      })
      .catch((err) => {
        if (err.response) {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.response.data.error
              ? err.response.data.error.message
              : err,
          };
          this.setState({
            isLoading: false,
            replies_fetch: null,
          });
        }
      });
  };

  undoBroadcast = (order_id) => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/undo/broadcast`,
    })
      .then((res) => {
        //console.log("res>>", res);
        if (res.status == 200) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log("shipment order failed >>> ", err.data);
      });
  };

  undoAllotToVendor = (order_id, vendor_id, order_detail) => {
    let no = customerNo;
    // if (no == 1122 || no == 1123 ) {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/allocate/vendor/${vendor_id}/undo`,
      payload: order_detail.remarks && { remarks: order_detail.remarks }
    })
      .then((res) => {
        //${process.env.REACT_APP_TA_API_URL}
        //console.log("res>>", res);
        // if (res.status == 200) {
        window.location.reload();
        // }
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: err.response?.data?.message || "Couldn't undo the order.",
        };
        this.props.errorAlertDispatcher(alert);
        console.log("shipment order failed >>> ", err.response?.data?.message);
      });
    // } else {
    //     let podetails = {"poReferenceNo" : order_detail.purchase_order_no};
    //   if (order_detail.purchase_order_no != null && order_detail.hire_memo_id != null) {
    //     DeleteAxios({
    //       completeURL: `${process.env.REACT_APP_BASE_COMMON}/hm/delete/${order_detail.hire_memo_id}`,
    //       })
    //         .then((res) => {
    //           console.log('res>>', res);
    //           CreateAxios({
    //             completeURL: `${process.env.REACT_APP_BASE_COMMON}/purchase/purchaseorder/delete`,
    //             payload: { ...podetails },
    //           })
    //             .then((res) => {
    //               CreateAxios({
    //                 completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/allocate/vendor/${vendor_id}/undo`,
    //               })
    //                 .then((res) => {
    //                   console.log('res>>', res);
    //                   // if (res.status == 200) {
    //                     window.location.reload()
    //                   // }
    //                 })
    //                 .catch((err) => {
    //                   console.log("shipment order failed >>> ", err.data);
    //                 });
    //               // if (res.status == 200) {
    //               //   window.location.reload()
    //               // }
    //             })
    //             .catch((err) => {
    //               console.log("shipment order failed >>> ", err.data);
    //             });
    //           // if (res.status == 200) {
    //           //   window.location.reload()
    //           // }
    //         })
    //         .catch((err) => {
    //           console.log("shipment order failed >>> ", err.data);
    //         });
    //   }else {
    //     CreateAxios({
    //       completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/allocate/vendor/${vendor_id}/undo`,
    //     })
    //       .then((res) => {
    //         console.log('res>>', res);
    //         // if (res.status == 200) {
    //           window.location.reload()
    //         // }
    //       })
    //       .catch((err) => {
    //         console.log("shipment order failed >>> ", err.data);
    //       });
    //   }
    // }
  };

  reloadCurrentPage = () => {
    this.props.history.go();
  };

  render() {
    const { t } = this.props;
    const {
      openViewModal,
      openVehicleModal,
      openVehicleDetailsModal,
      order_fetch,
      replies_fetch,
    } = this.state;

    return order_fetch ? (
      <>
        <Table className="w3-small" size="small" striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="p-bold-500">
                {shipmentTableBookingNumberHeaderCell ? 'Booking Number' : t("table_header.order_no") || "Order Number"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.reference_no") || "Reference Number"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.gross_weight") || "Gross Weight"}
              </Table.HeaderCell>
              {ALL_ALLOW_ROLES ? (
                <>
                  {order_fetch.freight_rate ? (
                    <>
                      <Table.HeaderCell className="p-bold-500">
                        {t("table_header.final_rate") || "Final Rate"}
                      </Table.HeaderCell>
                    </>
                  ) : null}
                </>) : (null)}
              {order_fetch.allotment_status &&
                order_fetch.allotment_status.allotment_code === order_allotment_status.broadcast ? (
                <>
                  {ALL_ALLOW_ROLES ? (
                    <Table.HeaderCell className="p-bold-500">
                      {t("table_header.base_rate") || "Base Rate"}
                    </Table.HeaderCell>
                  ) : null}
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.uom") || "UOM"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.return_load") || "Return Load"}
                  </Table.HeaderCell>
                </>
              ) : null}
              {/* <Table.HeaderCell className="p-bold-500">
                {t("table_header.net_weight") || "Net Weight"}
              </Table.HeaderCell> */}
              {order_fetch.vendor_name && (
                <Table.HeaderCell className="p-bold-500">
                  {t(
                    !usePartnerInsteadOfVendor
                      ? "table_header.vendor"
                      : "table_header.partner"
                  ) || "Vendor"}
                </Table.HeaderCell>
              )}
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.status") || "Status"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.view") || "View"}
              </Table.HeaderCell>
              {order_fetch.allotment_status &&
                order_fetch.allotment_status.allotment_code === order_allotment_status.reject ? (
                <>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.allot") || "Allot"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.broadcast") || "Broadcast"}
                  </Table.HeaderCell>
                </>
              ) : (
                <>
                  {!order_fetch.allotment_status ? (
                    <>
                      <Table.HeaderCell className="p-bold-500">
                        {t("table_header.allot") || "Allot"}
                      </Table.HeaderCell>
                      {/* <Table.HeaderCell className="p-bold-500">
                        {t("table_header.broadcast") || "Broadcast"}
                      </Table.HeaderCell> */}
                    </>
                  ) : null}
                </>
              )}
              
              {order_fetch.allotment_status &&
                (!order_fetch.allotment_status ||
                  order_fetch.allotment_status.allotment_code === order_allotment_status.allocated ||
                  order_fetch.allotment_status.allotment_code === order_allotment_status.accepted ||
                  order_fetch.allotment_status.allotment_code ===
                  order_allotment_status.waitingForVehicle) && (
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_details") || "Vehicle Details"}
                  </Table.HeaderCell>
                )}
              
              {(order_fetch.allotment_status &&
                order_fetch.allotment_status.allotment_code === order_allotment_status.reject) ||
                (!order_fetch.allotment_status && (
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.broadcast") || "Broadcast"}
                  </Table.HeaderCell>
                ))}

             <Table.HeaderCell className="p-bold-500">
               {t("table_header.history_status") || "History Status"}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <>
              <Table.Row>
                <Table.Cell>{order_fetch.order_no}</Table.Cell>
                <Table.Cell>{order_fetch.order_reference_no}</Table.Cell>
                <Table.Cell>{order_fetch.gross_weight}</Table.Cell>
                {ALL_ALLOW_ROLES ? (
                  <>
                    {order_fetch.freight_rate ? (
                      <Table.Cell>{order_fetch.freight_rate}</Table.Cell>
                    ) : null}
                  </>
                ) : null}
                {order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === order_allotment_status.broadcast ? (
                  <>
                    {ALL_ALLOW_ROLES ? (
                      <Table.Cell>
                        {order_fetch.broadcast
                          ? order_fetch.broadcast.base_rate
                            ? order_fetch.broadcast.base_rate
                            : "NA"
                          : "NA"}
                      </Table.Cell>
                    ) : null}
                    <Table.Cell>
                      {order_fetch.broadcast
                        ? order_fetch.broadcast.uom
                          ? order_fetch.broadcast.uom
                          : "NA"
                        : "NA"}
                    </Table.Cell>
                    <Table.Cell>
                      {order_fetch.broadcast
                        ? order_fetch.broadcast.return_load == true
                          ? "Available"
                          : "Not-Available"
                        : "NA"}
                    </Table.Cell>
                  </>
                ) : null}
                {/* <Table.Cell>{order_fetch.net_weight}</Table.Cell> */}
                {order_fetch.vendor_name && (
                  <Table.Cell>{order_fetch.vendor_name}</Table.Cell>
                )}
                <Table.Cell>
                  {order_fetch.allotment_status ? (
                    order_fetch.allotment_status.allotment_text
                  ) : (
                    <>{t("table_header.create") || "Created"}</>
                  )}{" "}
                  &nbsp;
                  {order_fetch.allotment_status &&
                    order_fetch.allotment_status.allotment_code == order_allotment_status.broadcast ? (
                    <>
                      <br></br>
                      {/* {this.props.auth.role == "Quality Control" ? (
                          null
                        ) : (
                      <ModalReBroadcast
                        order={order_fetch}
                        reFetchOrder={this.reloadCurrentPage}
                        shipmentId={this.props.shipmentId}
                      />
                        )} */}
                      {replies_fetch ? (
                        <>
                          {noModalUndoBroadcastRoles ? null : (
                            <ModalUndoBroadcast
                              orderID={order_fetch.vendor_order_id}
                              shipmentId={this.props.shipmentId}
                            />
                          )}

                          {/* <Button
                          type="button"
                          onClick={() =>
                            this.undoBroadcast(
                              order_fetch.vendor_order_id,
                            )
                          }
                          size="mini"
                          basic color="primary"
                          // className="w3-blue w3-round w3-hover-blue"
                        >
                          {"undo"}
                        </Button> */}
                        </>
                      ) : null}
                    </>
                  ) : null}{" "}
                  &nbsp;
                  {order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code !== order_allotment_status.broadcast &&
                    !consigneeConsignorCheck(this.props.auth.role) &&
                    order_fetch.undo_vendor_possible ? (
                    remarksOnUndoAllotVendor ? <ModalUndoAllotedVendor undoAllotToVendor={this.undoAllotToVendor} orderDetails={order_fetch} /> :
                      <Button
                        type="button"
                        disabled={
                          ShipmentUndoBtnDisabled
                            ? true
                            : false
                        }
                        onClick={() =>
                          this.undoAllotToVendor(
                            order_fetch.vendor_order_id,
                            order_fetch.vendor_id,
                            order_fetch
                          )
                        }
                        size="mini"
                        basic
                        color="primary"
                      // className="w3-blue w3-round w3-hover-blue"
                      >
                        {t("action_button.undo") || "Undo"}
                      </Button>

                  ) : null}
                </Table.Cell>
                <Table.Cell>
                  <Button
                    size="mini"
                    basic
                    color="primary"
                    icon
                    onClick={(e) => this.handleModelOpen(e)}
                  >
                    <Icon name="eye" />
                  </Button>
                </Table.Cell>
                {order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === order_allotment_status.reject ? (
                  <>
                    <Table.Cell>
                      {noModalAllotRole ? (
                        "NA"
                      ) : (
                        <FormikModalAllot
                          order={order_fetch}
                          role={this.props.auth.role}
                          reFetchOrder={this.fetchOrderDetails}
                          permissions={this.props.permissions}
                        // success={props.successAlertDispatcher()}
                        // error={props.errorAlertDispatcher()}
                        />
                      )}
                    </Table.Cell>
                  </>
                ) : (
                  <>
                    {!order_fetch.allotment_status ? (
                      <Table.Cell>
                        {noModalAllotRole ||
                          this.props.permissions.TA_SHIPMENT.UPDATE != true ? (
                          "NA"
                        ) : (
                          <FormikModalAllot
                            order={order_fetch}
                            role={this.props.auth.role}
                            reFetchOrder={this.fetchOrderDetails}
                            permissions={this.props.permissions}
                          // success={props.successAlertDispatcher()}
                          // error={props.errorAlertDispatcher()}
                          />
                        )}
                      </Table.Cell>
                    ) : null}
                  </>
                )}
                {order_fetch.allotment_status &&
                  (!order_fetch.allotment_status ||
                    order_fetch.allotment_status.allotment_code === order_allotment_status.allocated ||
                    order_fetch.allotment_status.allotment_code === order_allotment_status.accepted ||
                    order_fetch.allotment_status.allotment_code === order_allotment_status.waitingForVehicle) && (
                    <>
                      <Table.Cell>
                        <Button
                          type="button"
                          onClick={this.handleVehicleModelOpen}
                          size="mini"
                          basic
                          color="blue"
                          className="w3-blue w3-round w3-hover-blue"
                        >
                          {t("vtitle") || "Vehicle Detail"}
                        </Button>
                      </Table.Cell>
                      {/* <Table.Cell>
                        <Button
                          type="button"
                          onClick={this.handleVehicleModelOpen}
                          size="mini"
                          basic
                          color="blue"
                          className="w3-blue w3-round w3-hover-blue"
                        >
                          check me
                        </Button>

                      </Table.Cell> */}
                    </>
                  )}

                {/* {(order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === order_allotment_status.reject) ||
                  (!order_fetch.allotment_status && (
                    <Table.Cell>
                      {this.props.auth.role == "Quality Control" ||
                      this.props.permissions.TA_SHIPMENT.UPDATE != true ? (
                        "NA"
                      ) : (
                        <ModalBroadCast
                          order={order_fetch}
                          role={this.props.auth.role}
                          reFetchOrder={this.reloadCurrentPage}
                          shipmentId={this.props.shipmentId}
                        />
                      )}
                    </Table.Cell>
                  ))} */}
               
                {order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === order_allotment_status.reject ? (
                  <>
                    <Table.Cell>
                      {noModalBroadcastRole ? (
                        "NA"
                      ) : (
                        <ModalBroadCast
                          order={order_fetch}
                          role={this.props.auth.role}
                          reFetchOrder={this.reloadCurrentPage}
                          shipmentId={this.props.shipmentId}
                        />
                      )}
                    </Table.Cell>
                  </>
                ) : (
                  <>
                    {!order_fetch.allotment_status ? (
                      <Table.Cell>
                        {noModalBroadcastRole ||
                          this.props.permissions.TA_SHIPMENT.UPDATE != true ? (
                          "NA"
                        ) : (
                          <ModalBroadCast
                            order={order_fetch}
                            role={this.props.auth.role}
                            reFetchOrder={this.reloadCurrentPage}
                            shipmentId={this.props.shipmentId}
                          />
                        )}
                      </Table.Cell>
                    ) : null}
                  </>
                )}

                 <Table.Cell>
                  <Button
                    size="mini"
                    basic
                    color="primary"
                    icon
                    onClick={(e) => this.historyModal(e)}
                  >
                    <Icon name="history" />
                  </Button>
                </Table.Cell>
              </Table.Row>
              {openVehicleModal && (
                <ModalVehicleDetail
                  order={order_fetch}
                  vehicleNumber={order_fetch.vehicle_number}
                  vehicleType={order_fetch.proposed_vehicle_type}
                  ownerShipType={order_fetch.ownership_type_id}
                  OpenModal={openVehicleModal}
                  shipmentDetails={this.props.shipmentDetails}
                  role={this.props.auth.role}
                  order_id={order_fetch.vendor_order_id}
                  reFetchOrder={this.fetchOrderDetails}
                  allotment_status={order_fetch.allotment_status}
                  CloseModal={() => this.setState({ openVehicleModal: false })}
                />
              )}
              {/* {openVehicleDetailsModal && (
                <VehicleDetailsModal
                  order={order_fetch}
                  vehicleNumber={order_fetch.vehicle_number}
                  vehicleType={order_fetch.proposed_vehicle_type}
                  ownerShipType={order_fetch.ownership_type_id}
                  OpenModal={openVehicleDetailsModal}
                  role={this.props.auth.role}
                  order_id={order_fetch.vendor_order_id}
                  reFetchOrder={this.fetchOrderDetails}
                  allotment_status={order_fetch.allotment_status}
                  CloseModal={() =>
                    this.setState({ openVehicleDetailsModal: false }
                    )
                  }
                />
              )} */}
              {openViewModal && (
                <OrderDetails
                  movement_type={this.props.movement_type}
                  edit={this.props.permissions.TA_SHIPMENT.UPDATE}
                  role={this.props.auth.role}
                  budgeted_kms={this.props.budgeted_kms}
                  currenOrder={order_fetch}
                  OpenModal={openViewModal}
                  reFetchOrder={this.fetchOrderDetails}
                  CloseModal={() =>
                    this.setState({ openViewModal: false }, () =>
                      this.fetchOrderDetails()
                    )
                  }
                  size="large"
                />
              )}
              {/* modal for undo remarks */}
              {this.state.historyModal ?
                <StatusHistory
                  show={this.state.historyModal}
                  vendor_order_id={this.state.vendor_order_id}
                  handleClose={() => this.setState({ historyModal: false })}
                />
                : ''}


            </>
          </Table.Body>
        </Table>
      </>
    ) : (
      <>
        <LoadingPlaceholder />
      </>
    );
  }
}

const mapStateToProps = ({ permissions, auth }) => {
  return {
    permissions,
    auth,
  };
};

export default connect(mapStateToProps, { successAlertDispatcher, errorAlertDispatcher })(
  translate("order_list")(ShipmentOrderTable)
);
